module.exports = __webpack_public_path__ + "img/conversions-stamp.702c3e3e.svg";